import { GetBearerToken } from "./BearerToken";
import { getImpersonateHeaders } from "./ApiClientConfig";

interface FetchOptions {
  method?: string;
  headers?: Record<string, string>;
  body?: string;
  [key: string]: unknown;
}

export default async function AuthFetch(fetch: (url: string, options?: FetchOptions) => Promise<Response>, url: string, options?: FetchOptions) {

  const token = await GetBearerToken();
  const o: FetchOptions = options ?? {};
  if (!o.headers) o.headers = {};
  const { impersonateUserId, assumeIdentity, impersonateAccount, demoData, impersonateEmail } = getImpersonateHeaders();
  if (impersonateUserId) o.headers.ImpersonateUserId = impersonateUserId;
  if (assumeIdentity) o.headers.AssumeIdentity = assumeIdentity;
  if (impersonateAccount) o.headers.ImpersonateAccount = impersonateAccount;
  if (demoData) o.headers.DemoData = demoData;
  if (impersonateEmail) o.headers.ImpersonateEmail = impersonateEmail;
  o.headers.Authorization = `Bearer ${token}`;
  return fetch(url, o);
}